import React from 'react';
import styled from 'styled-components/macro';
import autobg from 'autobg.macro';
import qs from 'qs';

import LongPage from 'rpf/react/components/LongPage';
import vw from 'rpf/un/vw';
import link from 'configs/link';
import { track, trackMap } from 'track';

const Wrap = styled(LongPage)`
  position: relative;
`;
const map = {
  master: {
    height: 7784,
    itemH: 973,
    btnImg: autobg('assets/img/detail/btn_return_red.png'),
    btnBottom: vw(66),
    signTop: vw(4558),
    signLeft: vw(174)
  },
  visa: {
    height: 14963,
    itemH: 1871,
    btnImg: autobg('assets/img/detail/btn_return_blue.png'),
    btnBottom: vw(78),
    signTop: vw(3311),
    signLeft: vw(154)
  }
};

const BgWrap = styled.div`
  width: ${vw(750)};
  height: ${p => vw(map[p.type].height)};
  transform: translateZ(0);
  line-height: 0;
  font-size: 0;
`;

const Bg = styled.img`
  display: block;
  /* position: absolute;
  left: 0;
  top: ${p => vw(p.idx * map[p.type].itemH)}; */
  width: 100%;
  height: ${p => vw(map[p.type].itemH)};
`;

const SignBtn = styled.div`
  ${autobg('assets/img/detail/btn_sign.png')}
  position: absolute;
  left: ${p => map[p.type].signLeft};
  top: ${p => map[p.type].signTop};
  margin: 0 auto;
`;

const BackBtn = styled.div`
  ${p => map[p.type].btnImg}
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${p => map[p.type].btnBottom};
  margin: 0 auto;
`;

const Detail = props => {
  const { type } = qs.parse(props.location.search.slice(1));

  const toLink = () => {
    const map = {
      visa: 'Visa',
      master: '万事达'
    };
    track(trackMap[`详情_${map[type]}`]);
    window.location.href = link[`d${type}`];
  };

  return (
    <Wrap>
      <BgWrap type={type}>
        {Array(8)
          .fill('')
          .map((_, idx) => (
            <Bg
              src={
                require(`assets/img/detail/bg_${type}_0${idx + 1}.jpg`).default
              }
              type={type}
              idx={idx}
              key={idx}
              alt=""
            />
          ))}
      </BgWrap>
      <SignBtn type={type} onClick={toLink} />
      <BackBtn type={type} onClick={() => props.history.replace('/')} />
    </Wrap>
  );
};

export default Detail;
